'use client';

import useControlled from '@mui/utils/useControlled';
export default useControlled;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useControlled.js
// module id = 168
// module chunks = 25